import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@material-ui/core';
import FacebookIcon from '../icons/Facebook';
import GoogleIcon from '../icons/Google';
import ServiceUser from 'src/services/User';
import { useState } from 'react';
import AppConfig from 'src/AppConfig';
import { login, setLoja } from 'src/daos/auth';


const Login = () => {
  const navigate = useNavigate();

  const [buttonDisable, setButtonDisable] = useState(false);

  const logar = (email, password) => {
    var json = {
      "email": email,
      "password": password
    }
    
    ServiceUser.authenticate(json).then(response => {
      if(!response.data.loja && response.data.profile == 'admin'){
        alert("Seu usuário não tem vínculo com nenhuma loja, por favor entre em contato com o administrador do sistema.")
        setButtonDisable(false)
      }else{
        login(response.data.accessToken, response.data.id, response.data.name, response.data.profile);
        setLoja(response.data.loja)
        //if tem mais de uma loja
        if(response.data.profile == "sysAdminMktPlc"){
          navigate('/adm/painel', { replace: true });
        }else{
          navigate('/app/painel', { replace: true });
        }
      }
    }).catch(error => {
        alert("Não foi possível efetuar o Login")
        setButtonDisable(false)
        console.log(error);
    });
  }


  return (
    <>
      <Helmet>
        <title>{'Login | '+AppConfig.sigla}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
              password: Yup.string().max(255).required('Password is required')
            })}
            onSubmit={(values) => {
              setButtonDisable(true)
              logar(values.email, values.password)
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    color="primary"
                    variant="h2"
                  >
                    {AppConfig.nome}
                  </Typography>
                  
                </Box>

                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Senha"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    disabled={buttonDisable}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Entrar
                  </Button>
                </Box>
                {/*<Typography
                  color="textSecondary"
                  variant="body1"
                >
                  Don&apos;t have an account?
                  {' '}
                  <Link component={RouterLink} to="/register" variant="h6" underline="hover">
                    Sign up
                  </Link>
                </Typography> */}
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
